var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWrite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3772 4.5944l5.9072 5.7837h-5.9165l.0093-5.7837zM33 41.6434v-5.5757h-2.7712v4.219H2.7712V2.6817h16.8256v9.044c0 .7493.6203 1.3566 1.3856 1.3566h9.2372v4.703h2.7712V11.712c.0009-.359-.1437-.7037-.4019-.9587L21.9661.3889A1.3987 1.3987 0 0 0 21.1255 0H1.3856C.6203 0 0 .6073 0 1.3566v40.2868C0 42.3927.6203 43 1.3856 43h30.2288C32.3797 43 33 42.3927 33 41.6434z",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#D8D8D8",
    x: 7,
    y: 34,
    width: 12,
    height: 2.5,
    rx: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#D8D8D8",
    x: 7,
    y: 28,
    width: 12,
    height: 2.5,
    rx: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#D8D8D8",
    x: 7,
    y: 22,
    width: 15,
    height: 2.5,
    rx: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6851 33.955l-2.6805.1577.5406-2.6644 11.1064-10.1055 2.1177 2.516L27.685 33.9549zm10.1013-15.4808c-.4874-.5775-1.3331-.6355-1.8898-.13L23.4365 29.6565c-.2252.1959-.382.4637-.4468.7613l-.9605 4.9018c-.1528.7525.31 1.4915 1.0342 1.6502.092.0205.1854.0302.2792.0302h.0939l4.883-.2878c.299-.0176.5835-.1383.8087-.3435l12.4155-11.3123c.5557-.5065.6116-1.3852.125-1.9636l-3.8823-4.6186z",
    fill: "#DFDFDF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrite);
export default __webpack_public_path__ + "static/media/Write.9aa2a37f30eb545b9a2bf28d11454b6e.svg";
export { ForwardRef as ReactComponent };